export default __webpack_public_path__ + "3f4caa9d1e1ab1f788fdddc110e72cec.png";